module.exports = __webpack_public_path__ + "static/media/360photo.402e0129.jpg";